import { useDispatch, useSelector } from 'react-redux';
import { setIsXREnabled } from '../redux_stores/xrReducer';
import { isAppleDevice, checkDeviceEnabled } from '../utils/xrUtils';
import { createSelector } from '@reduxjs/toolkit';

const xrDataSelector = createSelector(
	[(state) => state.xrReducer],
	(xrReducer) => {
		const { isXREnabled, xrSessionType, xrOptionalFeatures } =
			xrReducer || {};
		return {
			isXREnabled,
			xrSessionType,
			xrOptionalFeatures,
		};
	},
);

const useXR = () => {
	const dispatch = useDispatch();

	const { isXREnabled, xrSessionType, xrOptionalFeatures } =
		useSelector(xrDataSelector);

	return {
		setIsXREnabled: (xrState) => {
			dispatch(setIsXREnabled(xrState));
		},
		handleXRSessionEnd: () => {
			dispatch(setIsXREnabled({ isXREnabled: false }));
			// fix window sizing on next tick
			setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
		},
		isAppleDevice,
		checkDeviceEnabled: (enabledDevices) => {
			return checkDeviceEnabled(enabledDevices);
		},
		isXREnabled,
		xrSessionType,
		xrOptionalFeatures,
	};
};

export default useXR;
